import React, { forwardRef, memo, RefObject } from "react";
import { PlainSelectWrapper, PlainSelectShadowWrapper } from "../styled";
import cs from "classnames";
import Scrollbars from "rc-scrollbars";
import { openSafeWindow } from "util/SaasUtils";

declare const Placements: [
  "topLeft",
  "topCenter",
  "topRight",
  "bottomLeft",
  "bottomCenter",
  "bottomRight",
];
declare type Placement = (typeof Placements)[number];

export interface Props {
  items:
    | Array<{
        name: React.ReactNode;
        key: string;
        value?: string | number;
        url?: string;
      }>
    | { [key: string]: React.ReactNode };
  onSelect: (key: any, item: any) => void;
  value?: string;
  height?: number;
  width?: number;
  scrollable?: boolean;
  withoutTheme?: boolean;
  placement?: Placement;
  trigger?: ("click" | "hover" | "contextMenu")[];
  menuWrapperRef?: RefObject<HTMLDivElement>;
  onVisibleChange?: (visible: boolean, dropdownName: string) => void;
  dropdownName?: string;
  customItem?: boolean;
  liStyle?: any;
  isStrategy?: boolean;
  searchKey?: string;
  setSearchKey?: (val) => void;
  overlayClassName?: string;
  showSearch?: boolean;
  selectWrapperClass?: string;
  dataTestIdMap?: {
    // testid  map数据
    [key: string]: React.ReactNode;
  };
}

const PlainSelect = (props: Props) => {
  let {
    items,
    onSelect,
    value,
    width,
    height,
    scrollable,
    withoutTheme,
    customItem = false,
    liStyle = {},
    isStrategy = false,
    showSearch = false,
    selectWrapperClass = "",
    dataTestIdMap = {},
  } = props;
  if (!Array.isArray(items)) {
    let temp = [];
    for (let key in items) {
      temp.push({ key, name: items[key] });
    }
    items = temp;
  }

  const content = (
    <PlainSelectWrapper
      isStrategy={isStrategy}
      showSearch={showSearch}
      withoutTheme={withoutTheme}
    >
      {items.map((item, index) => {
        return customItem ? (
          <li
            onMouseDown={() => {
              onSelect?.(item.key, item);
              if (item.url) {
                openSafeWindow(item.url);
              }
            }}
            key={index}
            className={cs(
              { "active !text-var(--content-primary)": value === item.key },
              "!hover:text-[var(--content-primary)]"
            )}
            data-testid={dataTestIdMap?.[item?.key]}
          >
            {item.name}
          </li>
        ) : (
          <li
            onMouseDown={(event) => {
              event.stopPropagation();
              onSelect?.(item.key, item);
            }}
            style={liStyle}
            key={index}
            className={
              isStrategy
                ? cs(
                    {
                      "active !text-var(--content-primary)": value === item.key,
                      "!text-var(--content-primary)": value !== item.key,
                    },
                    "!hover:text-primaryText"
                  )
                : cs({ active: value === item.key })
            }
            data-testid={dataTestIdMap?.[item?.key]}
          >
            {item.name}
          </li>
        );
      })}
    </PlainSelectWrapper>
  );
  return (
    <PlainSelectShadowWrapper
      className={selectWrapperClass}
      withoutTheme={withoutTheme}
      isStrategy
    >
      {scrollable ? (
        <Scrollbars
          style={{
            minWidth: (width || 120) + "px",
            height:
              (height ||
                (items.length >= 5 ? 5 : items.length) * 34 +
                  (isStrategy ? 80 : 30)) + "px",
          }}
        >
          {content}
        </Scrollbars>
      ) : (
        content
      )}
    </PlainSelectShadowWrapper>
  );
};

export default memo(forwardRef(PlainSelect));
